import React from 'react';
import { Link } from 'react-router-dom';
import { FaInstagram } from 'react-icons/fa';
import { useCms } from '../cms/CmsProvider';
import footerLogo from '../assets/img/logo/npocde logo.png';
import '../assets/styles/news.css';

const DEFAULT_INSTAGRAM = 'https://www.instagram.com/npo_fuk_cdes/';

const Footer = () => {
    const { t, text, image, site, isJa } = useCms('site');
    const orgName = text('organizationName', 'header.organizationName');
    const email = site.contactEmail || 'contact@fukuoka-cde.com';
    const instagramUrl = site.instagramUrl || DEFAULT_INSTAGRAM;

    return (
        <footer className="app-footer">
            <div className="footer-content">
                <div className="footer-logo-section">
                    <img
                        src={image("footerLogo", footerLogo)}
                        alt={orgName}
                        className="footer-logo"
                        onError={(e) => {
                            e.target.style.display = 'none';
                        }}
                    />
                    <p className="footer-org-name">{orgName}</p>
                </div>
                <div className="footer-contact">
                    <p>{text('footerAddress', 'footer.address')}</p>
                    <p><a href={`mailto:${email}`}>{site.contactEmail || t('footer.email')}</a></p>
                </div>
                <div className="footer-links">
                    <a
                        href={instagramUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="footer-instagram"
                        aria-label="Instagram"
                    >
                        <FaInstagram /> Instagram
                    </a>
                    <Link to="/tokusho">{t('tokushoPage.title')}</Link>
                </div>
            </div>
            <div className="footer-bottom">
                <p>&copy; {new Date().getFullYear()} {orgName}</p>
            </div>
        </footer>
    );
};

export default Footer;
